import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
	Button,
	TextField,
	MuiThemeProvider,
  FormControlLabel,
  FormHelperText,
	createMuiTheme,
  Checkbox
} from '@material-ui/core'
import Select from 'react-select'
import { useHistory, useParams } from 'react-router-dom'
import { deletePodcast, getPodcastById, postPodcast, updatePodcast } from '../../../../api/podcast'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import PreviewDialog from "../../../components/dialogs/PreviewDialog"
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { getTags } from '../../../../api/tag'
import { SERVER_URL } from "../../../../utils"
import Editor from '../../../components/editor/Editor'
import replaceSpecialCharacters from 'replace-special-characters'

// Create theme for delete button (red)
const theme = createMuiTheme({
	palette: {
		secondary: {
			main: '#F64E60'
		}
  }
})

function getEmptyPodcast() {
  return {
    fullName: {},
		summary: {},
		quote: {},
		content: {},
		image: '',
		imagevert: '',
		idpodcast: '',
		duration: '',
    tags: [],
		transmin: {},
		transtext: {},
		active: true,
    featured: false,
		seotitle: {},
		seodescription: {},
		seoURL: {},
		transcriptions: []
  }
}

const getDataSelect = (elements) => {
  const data = []
  for (const element of elements) {
    let elem = {}
    elem.label = element.fullName.es
    elem.value = element._id
    data.push(elem)
  }
  return data
}

export default function EditPodcastsPage() {
  const [podcast, setPodcast] = useState(getEmptyPodcast())
  const [newTranscription, setNewTranscription] = useState({minute: '', text: ''})
	const [selectedImage, setSelectedImage] = useState(null)
	const [selectedImagevert, setSelectedImagevert] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
	const [openPreviewImage, setOpenPreviewImage] = useState(false)
	const [openPreviewImagevert, setOpenPreviewImagevert] = useState(false)
	const [tags, setTags] = useState(null)
  const podcastId = useParams().id
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

	//console.log('tags', tags)
  useEffect(() => {
		getTags().then(resp => {
			if (resp.status === 200) {
				setTags(getDataSelect(resp.data))
			}
		}).catch(error => {
			alertError({ error: error, customMessage: 'Could not get tags.' })
			history.push('/podcasts')
		})
    if (!podcastId) {
      disableLoadingData()
      return
    }
    getPodcastById(podcastId).then(res => {
      if (res.status === 200) {
        setPodcast(res.data)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get podcast.' })
      history.push('/podcasts')
    })
  }, [podcastId, disableLoadingData, history])

  function savePodcast() {
		//console.log('podcast to save / update', podcast)
    if (!podcastId) {
      postPodcast(podcast, selectedImage, selectedImagevert).then(res => {
        if (res.status === 201) {
          alertSuccess({ title: 'Saved!', customMessage: 'Podcast successfully created.' })
          history.push('/podcasts')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save podcast.' })
      })
    } else {
      updatePodcast(podcastId, podcast, selectedImage, selectedImagevert).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
          history.push('/podcasts')
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save changes.' })
      })
    }
  }

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === ' ') return
      if (!podcast[element]) podcast[element] = {}
      let newText = podcast[element]
      newText[lang] = event.target.value
      setPodcast({ ...podcast, [element]: newText })
    } else setPodcast({ ...podcast, [element]: event.target.value })
  }

  const handleChangeSpecialChars = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === ' ') return
      if (!podcast[element]) podcast[element] = {}
      let newText = podcast[element]
      newText[lang] = replaceSpecialCharacters(event.target.value)
      setPodcast({ ...podcast, [element]: newText })
    } else setPodcast({ ...podcast, [element]: replaceSpecialCharacters(event.target.value) })
  }

	const handleChangeTags = new_selected => {
		setPodcast(prevPodcast => ({
			...prevPodcast,
			tags: new_selected.map(elem => elem.value) || []
		}))
	}

  const handleAddTranscription = lang => () => {
    setPodcast(prevPodcast => {
      let _transcriptions = prevPodcast.transcriptions
				?	{...prevPodcast.transcriptions }
				: {}
			if (!_transcriptions[lang]) _transcriptions[lang] = []
      _transcriptions[lang].push(newTranscription)
			//console.log('_transcriptions to save', _transcriptions)
      return {
        ...prevPodcast,
        transcriptions: _transcriptions
      }
    })
    setNewTranscription({minute: '', text: ''})
  }

	const handleEditTranscription = (lang, index) => editedTranscription => {
		setPodcast(prevPodcast => {
			let _transcriptions = prevPodcast.transcriptions
			? {...prevPodcast.transcriptions}
			: {}

			if(!_transcriptions[lang]) _transcriptions[lang] = []
			if (!_transcriptions[lang][index]) return

			_transcriptions[lang][index] = editedTranscription

			return {
				...prevPodcast,
				transcriptions: _transcriptions
			}

		})
	}

  const handleDeleteTranscription = lang => index => {
    setPodcast(prevPodcast => {
      let _transcriptions = prevPodcast.transcriptions
			?	{...prevPodcast.transcriptions }
			: {}
			if (!_transcriptions[lang]) _transcriptions[lang] = []
      _transcriptions[lang].splice(index, 1)
      return {
        ...prevPodcast,
        transcriptions: _transcriptions
      }
    })
  }

  const renderMultilanguageTabContent = lang => {
    return (
      <>
        <TextField
          id={`fullName`}
          label="Full name (internal name)"
          value={(podcast.fullName && podcast.fullName[lang]) || ''}
          onChange={handleChange('fullName', lang)}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="outlined"
          required
        />
        <TextField
          id={`duration`}
          label="Total duration (mm:ss)"
          value={podcast.duration || ''}
          onChange={handleChange('duration')}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="outlined"
          required
        />
				<TextField
					id={`summary`}
					label="Summary"
					value={(podcast.summary && podcast.summary[lang]) || ''}
					onChange={handleChange('summary', lang)}
					multiline={true}
					rows={4}
					InputLabelProps={{
						shrink: true
					}}
					margin="normal"
					variant="outlined"
					required
				/>
        <TextField
          id={`quote`}
          label="Quote"
          value={(podcast.quote && podcast.quote[lang]) || ''}
          onChange={handleChange('quote', lang)}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="outlined"
        />
				<Editor
				body={(podcast.content && podcast.content[lang]) || ''}
				setBody={_value => handleChange('content', lang)({target: {value: _value}})}
				className='max-height'
				/>
        <TextField
          id={`idpodcast`}
          label="ID Podcast IVOOX"
          value={podcast.idpodcast || ''}
          onChange={handleChange('idpodcast')}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="outlined"
          required
        />
			<FormHelperText>Copiar el código que aparece en la página de IVOOX de cada podcast</FormHelperText>
			<label className='mt-4' htmlFor={"upload-image"}>
					<input
						style={{ display: 'none' }}
						id={"upload-image"}
						name={"upload-image"}
						type="file"
						onChange={(e) => {
							setSelectedImage(e.target.files[0])
						}}
					/>
					<Button
						style={{ marginRight: '15px' }}
						color="secondary"
						component="span"
						variant="outlined">
						{((selectedImage || podcast.image !== '') ? 'Change image' : 'Upload image')}
					</Button>
				</label>
				{(selectedImage || podcast.image !== '') &&
					<>
						<Button
							onClick={() => setOpenPreviewImage(true)}
							style={{ marginRight: '15px' }}
							variant="outlined">
							{'Preview image'}
						</Button>
						<PreviewDialog
							title={'Preview image'}
							open={openPreviewImage}
							setOpen={setOpenPreviewImage}
							src={(selectedImage) ? URL.createObjectURL(selectedImage) : `${SERVER_URL}/${podcast.image}`}
						/>
					</>
			}<br/>
				<label className='mt-4' htmlFor={"upload-imagevert"}>
					<input
						style={{ display: 'none' }}
						id={"upload-imagevert"}
						name={"upload-imagevert"}
						type="file"
						onChange={(e) => {
							setSelectedImagevert(e.target.files[0])
						}}
					/>
					<Button
						style={{ marginRight: '15px' }}
						color="secondary"
						component="span"
						variant="outlined">
						{((selectedImagevert || podcast.imagevert !== '') ? 'Change image vertical' : 'Upload image vertical')}
					</Button>
				</label>
				{(selectedImagevert || podcast.imagevert !== '') &&
					<>
						<Button
							onClick={() => setOpenPreviewImagevert(true)}
							style={{ marginRight: '15px' }}
							variant="outlined">
							{'Preview image vertical'}
						</Button>
						<PreviewDialog
							title={'Preview image'}
							open={openPreviewImagevert}
							setOpen={setOpenPreviewImagevert}
							src={(selectedImagevert) ? URL.createObjectURL(selectedImagevert) : `${SERVER_URL}/${podcast.imagevert}`}
						/>
					</>
			}<br/>
				<Select
					options={tags}
					value={tags?.filter(tag => podcast.tags?.includes(tag.value))}
					onChange={handleChangeTags}
					isClearable
					isMulti
					isSearchable
					placeholder={`Select tags...`}
					className='mb-3 mt-3'
				/>
			<h5 className='mt-4'>Podcast transcription</h5>
				{podcast?.transcriptions && podcast?.transcriptions[lang] &&
				podcast.transcriptions[lang]?.map((elem, index) => <div>
					<TextField
						className='col-1'
						id={`transmin`}
						label="Minute"
						value={elem.minute || ''}
            // disabled={true}
						onChange={e => handleEditTranscription(lang, index)({minute: e.target.value, text: elem.text})}
						InputLabelProps={{
							shrink: true,
              // readOnly: true
						}}
						margin="normal"
						variant="outlined"
					/>
					<TextField
						className='col-10 pl-1'
						id={`transtext`}
						label="Text"
						value={elem.text || ''}
            // disabled={true}
						onChange={e => handleEditTranscription(lang, index)({text: e.target.value, minute: elem.minute})}						
						InputLabelProps={{
							shrink: true,
              // readOnly: true
						}}
						multiline={true}
						rows={3}
						margin="normal"
						variant="outlined"
					/>
		      <Button
          onClick={() => handleDeleteTranscription(lang)(index)}
						className='col-1 pl-1 mt-5'
		        variant="outlined">
		        Delete
		      </Button>
				</div>)}
        <TextField
						className='col-1'
						id={`transmin`}
						label="Minute"
						value={newTranscription.minute || ''}
						onChange={event => setNewTranscription({...newTranscription, minute: event.target.value})}
						InputLabelProps={{
							shrink: true
						}}
						margin="normal"
						variant="outlined"
					/>
					<TextField
						className='col-10 pl-1'
						id={`transtext`}
						label="Text"
						value={newTranscription.text || ''}
						onChange={event => setNewTranscription({...newTranscription, text: event.target.value})}
						InputLabelProps={{
							shrink: true
						}}
						multiline={true}
						rows={3}
						margin="normal"
						variant="outlined"
					/>
		      <Button
          onClick={handleAddTranscription(lang)}
						className='col-1 pl-1 mt-5'
		        variant="outlined">
		        Add
		      </Button>
				<hr/>
				<h5>SEO information</h5>
        <TextField
          id={`seotitle`}
          label="Title (60 chars aprox.)"
          value={(podcast.seotitle && podcast.seotitle[lang]) || ''}
          onChange={handleChange('seotitle', lang)}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="outlined"
        />
				<TextField
					id={`seodescription`}
					label="Description (160 chars aprox.)"
					value={(podcast.seodescription && podcast.seodescription[lang]) || ''}
					onChange={handleChange('seodescription', lang)}
					multiline={true}
					rows={2}
					InputLabelProps={{
						shrink: true
					}}
					margin="normal"
					variant="outlined"
				/>
				<TextField
          id={`seoURL`}
          label="URL"
          value={(podcast?.seoURL && podcast?.seoURL[lang]) || ''}
          onChange={handleChangeSpecialChars('seoURL', lang)}
          InputLabelProps={{
            shrink: true
          }}
          margin="normal"
          variant="outlined"
          required
        />
				<FormControlLabel
					control={<Checkbox checked={podcast.featured} onChange={() => setPodcast({ ...podcast, featured: !podcast.featured })} name="checkFeatured" />}
					label="Featured"
				/>
				<FormControlLabel
					control={<Checkbox checked={podcast.active} onChange={() => setPodcast({ ...podcast, active: !podcast.active })} name="checkActive" />}
					label="Active"
				/>
      </>
    )
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Edit podcast'>
        </CardHeader>
        <CardBody>
          <MultilanguageTabBlock
						multilanguageTabContent = {renderMultilanguageTabContent}
					/>
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/podcasts')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Back
      </Button>
      <Button
        onClick={() => savePodcast()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Save podcast
      </Button>
      {podcastId && <>
        <MuiThemeProvider theme={theme}>
          <Button
            onClick={() => setOpenConfirmDialog(true)}
            variant="outlined"
            color="secondary">
            Delete podcast
          </Button>
        </MuiThemeProvider>

        <ConfirmDialog
          title={'Are you sure you want to delete this podcast?'}
          open={openConfirmDialog}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deletePodcast(podcastId).then(res => {
              if (res.status === 204) {
                alertSuccess({ title: 'Deleted!', customMessage: 'Podcast deleted successfully' })
                history.push('/podcasts')
              }
            }).catch(error => {
              alertError({ error: error, customMessage: 'Could not delete economic sector.' })
            })
          }}
        />
      </>}
    </>
  );
}
